import { useRouteBodyState } from "@-/dev.improve.haniverse.lib.navigation.route-body-state";
import type { ReferenceGraphemeMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { Surface } from "@-/dev.improve.haniverse.components.ui.surface";
import {
  GraphemeDictionarySurfaceHeader,
  GraphemeDictionarySurfaceBody,
} from "#grapheme-dictionary-surface";

/** The combined Reference page still uses descriptors; the Details tab uses a top sheet. */
export function useMorphemeInfoPanelDictionaryOverviewGraphemeSection({
  graphemeCard,
}: {
  graphemeCard: ReferenceGraphemeMorphemeSlice;
}): MorphemeInfoPanelAccordionSectionDescriptor {
  const [isOpen, setIsOpen] = useRouteBodyState("grapheme-reference-overview-open", true);
  return {
    bodyKey: "morpheme-info-dictionary-overview-body",
    headerKey: "morpheme-info-dictionary-overview-header",
    iconName: "LuBookOpen",
    isOpen,
    onToggle: () => setIsOpen((previousState) => !previousState),
    renderBody: () => (
      <Surface className="m-2">
        <GraphemeDictionarySurfaceHeader graphemeCard={graphemeCard} />
        <GraphemeDictionarySurfaceBody graphemeCard={graphemeCard} />
      </Surface>
    ),
    title: "Overview",
  };
}
